<template>
  <div class="content md flex-box vertical">
    <div class="content-title">
      <div class="content-title-text">首页预览</div>
      <div class="content-title-btn">
        <a-button type="primary" @click="decorateActivity" v-if="editable">去装修</a-button>
      </div>
    </div>
    <div class="gap"></div>
    <div class="flex-grow" style="min-height: 0">
      <div class="preview-box" v-if="list">
        <control-list
          class="pre-box"
          :style="pageStyle"
          :controls="list"
          :onlyShow="true"
        ></control-list>
      </div>
      <div class="no-data" v-else>首页还未装修，请点击去装修</div>
    </div>
  </div>
</template>

<script>

    import controlList from "../../../components/control/control-list";
    import {getDistance} from "../../../common/js/tool";
    import mixins from "../mixins";

    export default {
        name: "ActivityHomePreview",
        components: {
            controlList,
        },
        provide() {
            return {
                setSelect: null,
                build: this,
            };
        },
        mixins: [mixins],
        data() {
            return {
                list: [],
                pageStyle: {},
                moduleKey: 'furnish-preview'
            }
        },
        computed: {
            activity() {
                return this.$store.getters.activity;
            },
        },
        watch: {
            activity() {
                this.getDecorateInfo();
            }
        },
        created() {
            this.getDecorateInfo();
        },
        methods: {
            decorateActivity() {
                this.$router.push({
                    name: "ActivityDecorate",
                    params: { id: this.activity.id },
                    query: { type: "act" },
                });
            },
            getDecorateInfo() {
                const activity = this.activity;
                if(activity && activity.config) {
                    let config = activity.config;
                    if (config) {
                        config = JSON.parse(config);
                        console.log("getDecorateInfo:", config);
                        this.list = config.list || [];
                        let page = config.page;
                        let style = {};
                        if (page.backgroundImage) {
                            style.backgroundImage = `url(${page.backgroundImage})`;
                        }
                        if (page.backgroundColor) {
                            style.backgroundColor = page.backgroundColor;
                        }
                        if (page.padding) {
                            style.padding = getDistance(page.padding);
                        }
                        this.pageStyle = style;
                    }
                } else {
                    this.list = null;
                }
            },
        }
    }
</script>

<style scoped lang="less">
  .preview-box {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 377px;
    height: 100%;
    background: url(../../../assets/bg.png) center / cover no-repeat, linear-gradient(180deg, #0b79ff 0%, #8ae7da 100%);
    margin: 0 auto;
    overflow: auto;
  }
</style>
